import { fromJS, Record } from '@gonfalon/immutable-shim/immutableShim';

export class Extinction extends Record({
  revision: '',
  message: '',
  time: 0,
}) {}

export function createExtinction(props = {}) {
  return props instanceof Extinction ? props : new Extinction(fromJS(props));
}
